import {
  Box,
  Button,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useTheme,
  Modal,
} from "@mui/material";
import { useState, useEffect } from "react";

interface DisplayInventoryProps {
  open: boolean;
  onClose: () => void;
  moveServiceId: number | null;
  allMoveServices: any;
}

const DisplayInventory: React.FC<DisplayInventoryProps> = ({
  open,
  onClose,
  moveServiceId,
  allMoveServices,
}) => {
  const theme = useTheme();
  const [inventoryData, setInventoryData] = useState<any[]>([]);
  useEffect(() => {
    if (allMoveServices) {
      const selectedMoveService = allMoveServices.find(
        (service: any) => service.id === moveServiceId
      );
      if (selectedMoveService?.inventory?.inventory) {
        try {
          const parsedData = JSON.parse(
            selectedMoveService.inventory.inventory
          );
          setInventoryData(Array.isArray(parsedData) ? parsedData : []);
        } catch (error) {
          console.error("Error parsing inventory data:", error);
          setInventoryData([]);
        }
      } else {
        setInventoryData([]);
      }
    } else {
      setInventoryData([]);
    }
  }, [moveServiceId, allMoveServices]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "80%",
          maxWidth: "900px",
          maxHeight: "90vh",
          overflow: "auto",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontWeight: "bold", mb: 3 }}
        >
          Inventory Details
        </Typography>

        <TableContainer component={Paper} elevation={3}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: theme.palette.primary.main }}>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  Room Name
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  Image
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  Object Name
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  Count
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  Bulky
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  Cubic Feet
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {inventoryData.length > 0 ? (
                inventoryData.map((room: any, roomIndex: number) =>
                  room.images.map((image: any, imageIndex: number) =>
                    image.items.map((item: any, itemIndex: number) => (
                      <TableRow key={`${roomIndex}-${imageIndex}-${itemIndex}`}>
                        {imageIndex === 0 && itemIndex === 0 && (
                          <TableCell
                            rowSpan={room.images.reduce(
                              (acc: any, img: any) => acc + img.items.length,
                              0
                            )}
                          >
                            <Typography
                              variant="h6"
                              sx={{ textAlign: "center" }}
                            >
                              {room.roomName}
                            </Typography>
                          </TableCell>
                        )}
                        {itemIndex === 0 && (
                          <TableCell
                            rowSpan={image.items.length}
                            sx={{ textAlign: "center" }}
                          >
                            <img
                              src={image.imageUrl}
                              alt="Room Image"
                              style={{
                                width: 130,
                                height: 130,
                                objectFit: "cover",
                                borderRadius: "7px",
                              }}
                            />
                            <Typography variant="h6">
                              Image: {imageIndex + 1}
                            </Typography>
                          </TableCell>
                        )}
                        <TableCell sx={{ textAlign: "center" }}>
                          {item.object_name}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {item.count}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {item.bulky ? "Yes" : "No"}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {item.predicted_dimensions
                            ? Math.ceil(
                                item.predicted_dimensions.reduce(
                                  (acc: number, val: number) => acc * val,
                                  1
                                )
                              )
                            : "N/A"}
                        </TableCell>
                      </TableRow>
                    ))
                  )
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No inventory data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={onClose}
            sx={{ mt: 2,color:"#fff" }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DisplayInventory;
